module.exports = __webpack_public_path__ + "img/money_bag.e95cb6c3.png";